

















































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';
import { Watch } from 'vue-property-decorator';

import Customer from '@/types/customer/Customer';
import UserInterface from '@/types/app/IUser';
import Investment, { investmentInitialValue } from '@/types/app/investment';
import VuetifySelectItems from '@/types/app/vuetifySelectItems';
import formatMoney from '@/utils/formatMoney';
import formatDate from '@/utils/formatDate';
import Endpoint from '@/utils/endpoint';

import compareTo from '@/utils/compareTo';
import AccountInterface, { accountInitialValue } from '@/types/app/accounts';
import product from '@/store/modules/product';
const namespace = 'customer';
interface ProductSelectValue {
  id: string;
  title: string;
  is506c?: boolean;
}
@Component({
  data: () => ({
    formType: '',
    account: accountInitialValue,
    required: (v: any) => !!v || 'This field is required',
    inputRule: (v: any) => v?.length >= 1 || 'Please select one option.',
  }),
})
export default class ModalDetail extends Vue {
  @Getter('getModalInvestmentState', { namespace })
  modalInvestmentState!: boolean;
  @Getter('getCustomer', { namespace }) customer!: Customer;
  @Getter('getLoading', { namespace }) loading!: boolean;
  @Getter('getUser', { namespace: 'auth' }) user!: UserInterface;
  @Getter('getCustomers', { namespace: 'customer' }) customers!: Customer[];
  @Getter('getInvesmentState', { namespace }) investmentState!: Investment;
  @Action('setInvestmentState', { namespace }) setInvestmentState!: any;
  @Action('setLoading', { namespace }) setLoading!: any;
  @Action('setModalInvestmentState', { namespace })
  setModalInvestmentState!: any;
  @Action('setModalRefuseState', { namespace }) setModalRefuseState!: any;
  @Action('setModalMessageState', { namespace }) setModalMessageState!: any;
  @Action('removeCustomerFromList', { namespace }) removeCustomerFromList!: any;

  customersOthers: VuetifySelectItems[] = [];
  private endpoint = new Endpoint();
  editInvestment = false;
  items = ['Documentation', 'Pending', 'Finalized'];
  formatDate = formatDate;
  formatMoney = formatMoney;
  selectedStatus = this.items[0];
  products: VuetifySelectItems[] = [];
  required = {};
  inputRule = {};

  @Watch('modalInvestmentState')
  loadInvestmentStatusOnSelect(newValue: boolean) {
    if (!newValue) return;

    this.selectedStatus = this.getLabelNameByStatus(
      this.investmentState.status
    );
  }

  async created() {
    this.setLoading(true);
    await this.getCustomers();

    const [productsResponse] = await Promise.all([this.getProducts()]);
    this.products = productsResponse;
    this.setLoading(false);
  }

  private get form(): HTMLFormElement {
    return this.$refs.form as HTMLFormElement;
  }

  async save() {
    if (this.form.validate()) {
      this.setLoading(true);
      const saveInvestmentEndpoint = this.endpoint.editOrCreateInvestment;
      const status = this.getStatusByLabelName(this.selectedStatus);
      try {
        await this.$http.post(saveInvestmentEndpoint, {
          productId: this.investmentState.productId,
          amount: this.investmentState.amount,
          customerId: this.investmentState.userId,
          status: this.investmentState.status,
        });
        this.closeModal();
        this.setLoading(false);
      } catch (error) {
        this.setLoading(false);
      }
    }
  }

  get isEdit() {
    return this.editInvestment;
  }

  get isNew() {
    return this.investmentState.id?.length == 0;
  }

  redirectToProductDetailPage(productId: string) {
    this.closeModal();

    
    this.$router.push({
      name: 'Subdocs',      
      query: { productId: productId },
    });
  }

  getLabelNameByStatus(status: number) {
    if (status === 0) {
      return 'Pending';
    }
    if (status === 1) {
      return 'Documentation';
    }
    if (status === 2) {
      return 'Finalized';
    }

    return 'Unknown Status';
  }

  getStatusByLabelName(label: string): number {
    if (label === 'Pending') {
      return 0;
    }
    if (label === 'Documentation') {
      return 1;
    }
    if (label === 'Finalized') {
      return 2;
    }

    return -1;
  }

  async getCustomers(): Promise<void> {
    const customerOrdened = [...this.customers];
    customerOrdened.sort((a, b) => a.fullName.localeCompare(b.fullName));

    const itemsForVuetifySelect = customerOrdened.map((item) => {
      return {
        text: `${item.fullName} - ${item.email}`,
        value: item.id,
        data: item,
      };
    });

    this.customersOthers = itemsForVuetifySelect;
  }

  async getProducts(): Promise<VuetifySelectItems[]> {
    const url = this.endpoint.productsOnlyPublished;
    const response = await this.$http.get(`${url}&pastOnly=false`);
    let productFunds = response.data as ProductSelectValue[];
    if(!productFunds)
      productFunds = [];
    const productFundsOrdened = productFunds.sort((a, b) =>
      compareTo(a.title, b.title)
    );

    const itemsForVuetifySelect = productFundsOrdened.map((productFund) => ({
      text: productFund.title,
      value: productFund.id,
      data: productFund,
    }));

    return itemsForVuetifySelect;
  }

  openExternalLink(link: string): void {
    window.open(link, '_blank');
  }

  showRefusement(): void {
    this.setModalRefuseState(true);
  }

  closeModal(): void {
    this.editInvestment = false;
    this.form.reset();
    this.setModalInvestmentState(false);
    this.investmentState.userId = '';
    this.investmentState.amount = 0;
    this.investmentState.id = '';
    this.investmentState.productId = '';
    this.setInvestmentState(investmentInitialValue);
  }
}
